<mat-card-title>
	Graduation Report
	<help-text-btn class="align-help-text-btn" [helpTextId]="'GraduationReport_Overview'"></help-text-btn>
</mat-card-title>
<p style="line-height:0px;">&nbsp;</p>
<mat-divider> </mat-divider><br>

<div class="row" style="padding-left:12px;">
	<mat-card appearance="outlined" class="col-lg-6">
		<mat-card-header>
			<mat-card-title>
				Search Criteria
			</mat-card-title>
		</mat-card-header>
		<mat-card-content>
			<region-dropdown-two-way [isMultiple]="true" [(selectedRegions)]="chosenRegions" [reset]="resetField"
				[required]="true" #appRegionCode>
			</region-dropdown-two-way>

			<county-dropdown-two-way [isMultiple]="true" [(selectedCounties)]="chosenCounties" [reset]="resetField"
				[required]="false" #appCountyCode [regions]="chosenRegions">
			</county-dropdown-two-way>

			<district-dropdown-two-way [isMultiple]="true" [(selectedSchoolDistricts)]="chosenSchoolDistricts"
				[reset]="resetField" [required]="false" #appSchoolDistrictCode [regions]="chosenRegions"
				[counties]="chosenCounties">
			</district-dropdown-two-way>

			<school-dropdown-two-way [isMultiple]="true" [(selectedSchools)]="chosenSchools" [reset]="resetField"
				#appSchoolsCode [regions]="chosenRegions" [counties]="chosenCounties"
				[schoolDistricts]="chosenSchoolDistricts">
			</school-dropdown-two-way>

			<app-school-year [yearType]="'SchoolYear'" (performancePeriodEvent)="performancePeriodEvent($event)"
				[reset]="resetField" [required]="true">
			</app-school-year>
		</mat-card-content>
		<mat-card-actions>
			<button mat-raised-button color="primary" mat-button [disabled]="!this.checkValid() || isLoading"
				(click)="search()" class="margin-right-xs">
				<mat-icon *ngIf="isLoading">
					<mat-spinner diameter="18"> </mat-spinner>
				</mat-icon>
				Search
			</button>
			<button mat-raised-button color="accent" (click)="reset()" mat-button class="margin-right-xs">Reset</button>
			<button [disabled]="!(results.length > 0)" mat-raised-button [matMenuTriggerFor]="menu">
				Export<mat-icon>more_vert</mat-icon>
			</button>
			<div class="spinner-overlay" *ngIf="isExporting && (progressCurrentValue < 100)">
				<mat-progress-spinner [color]="progressColor" [mode]="progressType" [value]="progressCurrentValue">
				</mat-progress-spinner>
			</div>
			<mat-menu #menu="matMenu">
				<button mat-menu-item (click)="downloadXLS()">
					<span>
						<i class="fa fa-file"></i>
						Export to Excel</span>
				</button>
				<!-- <button mat-menu-item (click)="downloadPDF()">
					<span>
						<i class="fa fa-file"></i>
						Export to PDF</span>
				</button> -->
			</mat-menu>
		</mat-card-actions>
	</mat-card>
</div>

<app-msg [msg]="msg" *ngIf="!msg.SUCCESS"></app-msg>

<div *ngIf="results.length > 0" class="margin-top-md">
	<h2>
		Graduation Report - {{results.length}} {{displayName}} {{'(' + currentPerformancePeriod + ')'}}
		<button mat-button [matMenuTriggerFor]="tableControlMenu" class="pull-right">
			<mat-icon>menu</mat-icon>
		</button>
		<mat-menu #tableControlMenu="matMenu">
			<button mat-menu-item (click)="expandAll(results)">
				<span>
					Expand All
				</span>
			</button>
			<button mat-menu-item (click)="collapseAll(results)">
				<span>
					Collapse All
				</span>
			</button>
		</mat-menu>
	</h2>
	<hr />
	<div *ngFor="let cur of results; let i = index" class="margin-top-sm">
		<div class="table-responsive">
			<h3>
				<span class="cursor-pointer" (click)="toggleShow(cur)">{{cur.CODE ? '(' + cur.CODE + ')' :
					''}} {{cur.NAME}}</span>
				<span class="cursor-pointer" (click)="toggleShow(cur)">{{cur.COUNTY_NAME}}</span>
				<span class="cursor-pointer" (click)="toggleShow(cur)">{{cur.DISTRICTS}}</span>
				<span class="cursor-pointer" (click)="toggleShow(cur)">{{cur.SCHOOL_NAME}}</span>

				<span class="cursor-pointer" (click)="toggleShow(cur)"> {{'(' + cur.STUDENTS!.length + ')'}}</span>

				<mat-icon class="v-align-middle cursor-pointer" [color]="cur.SHOW ? 'primary' : ''"
					(click)="toggleShow(cur)">
					{{cur.SHOW ? 'expand_more' : 'chevron_right'}}
				</mat-icon>
			</h3>

			<mat-table [dataSource]="tableDataSources[i]" class="mat-elevation-z1" matSort
				(matSortChange)="announceSortChange($event)" [hidden]="!cur.SHOW">
				<ng-container matColumnDef="SCHOOL.COUNTy.COUNTY_NAME">
					<mat-header-cell *matHeaderCellDef mat-sort-header> County </mat-header-cell>
					<mat-cell *matCellDef="let element"> {{element.SCHOOL.COUNTy.COUNTY_NAME}} </mat-cell>
				</ng-container>

				<ng-container matColumnDef="SCHOOL.SCHOOL_DISTRICT.DISTRICTS">
					<mat-header-cell *matHeaderCellDef mat-sort-header> District </mat-header-cell>
					<mat-cell *matCellDef="let element"> {{element.SCHOOL.SCHOOL_DISTRICT.DISTRICTS}} </mat-cell>
				</ng-container>

				<ng-container matColumnDef="SCHOOL.NAME">
					<mat-header-cell *matHeaderCellDef mat-sort-header> School </mat-header-cell>
					<mat-cell *matCellDef="let element"> {{element.SCHOOL.NAME}} </mat-cell>
				</ng-container>

				<ng-container matColumnDef="MSD_NUMBER">
					<mat-header-cell *matHeaderCellDef mat-sort-header> MSD Number </mat-header-cell>
					<mat-cell *matCellDef="let element">
						<edit-child-modal-btn [studentId]="element.ID" [type]="'string'"
							[displayText]="element.MSD_NUMBER">
						</edit-child-modal-btn>
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="SSID">
					<mat-header-cell *matHeaderCellDef mat-sort-header> SSID </mat-header-cell>
					<mat-cell *matCellDef="let element"> {{element.SSID}}</mat-cell>
				</ng-container>

				<ng-container matColumnDef="PERSON.LAST_NAME">
					<mat-header-cell *matHeaderCellDef mat-sort-header> Name </mat-header-cell>
					<mat-cell *matCellDef="let element"> {{element.PERSON.LAST_NAME |
						titlecase}}{{(element.SECOND_LAST_NAME
						? ' ' + element.SECOND_LAST_NAME + ',': ',') | titlecase}} {{element.PERSON.FIRST_NAME |
						titlecase}}
						{{element.PERSON.MIDDLE_INITIAL | titlecase}}</mat-cell>
				</ng-container>


				<ng-container matColumnDef="STUDENT_TERMINATION_STATUS_TYPE">
					<mat-header-cell *matHeaderCellDef mat-sort-header> Completion Type </mat-header-cell>
					<mat-cell *matCellDef="let element"> {{element.STUDENT_TERMINATION_STATUS_TYPE}} </mat-cell>
				</ng-container>

				<ng-container matColumnDef="STUDENT_TERMINATION_STATUS_DATE">
					<mat-header-cell *matHeaderCellDef mat-sort-header> Completion Date </mat-header-cell>
					<mat-cell *matCellDef="let element"> {{element.STUDENT_TERMINATION_STATUS_DATE | simpleDate}}
					</mat-cell>
				</ng-container>

				<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
				<mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
			</mat-table>
		</div>
		<mat-paginator #paginators [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons
			aria-label="Select page of periodic elements" [hidden]="!cur.SHOW">
		</mat-paginator>
	</div>
</div>